export class ApiError extends Error { constructor(public status: number, message: string, public data?: unknown) { super(message); } }

function cookie(name: string) {
  const value = document.cookie.split("; ").find((item) => item.startsWith(`${name}=`));
  return value ? decodeURIComponent(value.split("=").slice(1).join("=")) : "";
}

export async function api<T = any>(path: string, options: RequestInit = {}, retry = true): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body && !(options.body instanceof FormData)) headers.set("Content-Type", "application/json");
  const csrf = cookie("csrf_token");
  if (csrf && !["GET", "HEAD"].includes(options.method ?? "GET")) headers.set("X-CSRF-Token", csrf);
  const response = await fetch(`/api${path}`, { ...options, headers, credentials: "include" });
  if (response.status === 401 && retry && path !== "/auth/login" && path !== "/auth/refresh") {
    const refreshed = await fetch("/api/auth/refresh", { method: "POST", credentials: "include" });
    if (refreshed.ok) return api<T>(path, options, false);
  }
  const text = await response.text();
  const data = text ? JSON.parse(text) : null;
  if (!response.ok) throw new ApiError(response.status, data?.message ?? "请求失败", data);
  return data as T;
}

export function get<T = any>(path: string, options: RequestInit = {}) { return api<T>(path, options); }
export function post<T = any>(path: string, body?: unknown) { return api<T>(path, { method: "POST", body: body === undefined ? undefined : JSON.stringify(body) }); }
export function patch<T = any>(path: string, body: unknown) { return api<T>(path, { method: "PATCH", body: JSON.stringify(body) }); }
export function put<T = any>(path: string, body: unknown) { return api<T>(path, { method: "PUT", body: JSON.stringify(body) }); }
export function del<T = any>(path: string) { return api<T>(path, { method: "DELETE" }); }

export async function stream(path: string, body: unknown, onEvent: (event: string, data: any) => void, authorization?: string) {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  const csrf = cookie("csrf_token"); if (csrf) headers["X-CSRF-Token"] = csrf;
  if (authorization) headers.Authorization = `Bearer ${authorization}`;
  const response = await fetch(`/api${path}`, { method: "POST", credentials: "include", headers, body: JSON.stringify(body) });
  if (!response.ok || !response.body) { const data = await response.json().catch(() => ({})); throw new ApiError(response.status, data.message ?? "发送失败"); }
  const reader = response.body.getReader(); const decoder = new TextDecoder(); let buffer = "";
  while (true) {
    const { done, value } = await reader.read(); if (done) break; buffer += decoder.decode(value, { stream: true });
    const frames = buffer.split("\n\n"); buffer = frames.pop() ?? "";
    for (const frame of frames) { const lines = frame.split("\n"); const event = lines.find((line) => line.startsWith("event:"))?.slice(6).trim() ?? "message"; const raw = lines.find((line) => line.startsWith("data:"))?.slice(5).trim(); if (raw) onEvent(event, JSON.parse(raw)); }
  }
}
